import React from "react";
import PropTypes from "prop-types";

import { loginTypeConstant } from "../../../../constant/loginType/loginTypeConstant";

const RightDetail = ({ userDetails, loginType = "Employee" }) => (
  <div className="card bg-primary">
    <div className="card-body profile-user-box">
      <div className="media">
        <div className="media-body">
          <h4 className="mt-1 mb-1 text-white">
            {userDetails?.workerFirstName +
              " " +
              userDetails?.workerSurname}
          </h4>
          <p className="font-13 text-white-50">
            {userDetails?.workerDepartment +
              " / " +
              userDetails?.workerDesignation}
          </p>

          <ul className="mb-0 list-inline text-light">
            <li className="list-inline-item mr-3">
              <h5 className="mb-1">{userDetails.workerId}</h5>
              <p className="mb-0 font-13 text-white-50">
                {userDetails.workerType === loginTypeConstant.Employee
                  ? "Employee ID"
                  : "Worker ID"}
              </p>
            </li>
            <li className="list-inline-item  mr-3">
              <h5 className="mb-1">
                {userDetails.allowFencing
                  ? "Activate"
                  : "De-Activate"}
              </h5>
              <p className="mb-0 font-13 text-white-50">
                Geo-fencing
              </p>
            </li>
            <li className="list-inline-item">
              <h5 className="mb-1">
                {userDetails.isActive ? "REGULAR" : "DE-ACTIVATE"}
              </h5>
              <p className="mb-0 font-13 text-white-50">Status</p>
            </li>
            <li className="list-inline-item">
              <h5 className="mb-1">
                {userDetails.workerAadharCardNumber}
              </h5>
              <p className="mb-0 font-13 text-white-50">
                Aadhar Card Number
              </p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
);

RightDetail.propTypes = {
  userDetails: PropTypes.object.isRequired,
  loginType: PropTypes.string.isRequired
};

export default RightDetail;
